import { useRouteError } from 'react-router';
import { type ConfigObject, DebugLevel } from '../../_configs/types';
import ErrorCard from '../../components/error-card';
import useLocales from '../../hooks/useLocales';
import { type Translations } from '../../locales/translations';
import { type CustomErrorType } from '../../provider/ErrorHandler';
import checkUndefinedNullOrEmpty from '../../utils/tools/checkUndefinedNullOrEmpty';
import { LOCALSERVER } from '../../vars';
import { type Modules } from '../_definition/types';

type ErrorBoundaryProps = {
    module: Modules;
    settings: ConfigObject;
};

export default function ErrorBoundary(props: ErrorBoundaryProps) {
    const { module, settings } = props;
    const error: any = useRouteError();
    const { translate } = useLocales();

    const realError: CustomErrorType = {
        code: !checkUndefinedNullOrEmpty(error?.status) ? 'networkError' : 'unknown',
        message: error?.error?.message || error?.message,
        stack: error?.error?.stack || error?.stack,
    };
    const code = realError?.code as keyof Translations['errorHandler']['sIntErrors'];

    return (
        <ErrorCard
            collapse={
                ['unknown', 'networkError', 'runtimeError'].includes(realError?.code)
                    ? {
                          code: checkUndefinedNullOrEmpty(realError?.code) ? 'unknown' : realError?.code,
                          message: checkUndefinedNullOrEmpty(realError?.code) ? realError?.message : translate(`common:errorHandler.sIntErrors.${code}.title`),
                          stack: LOCALSERVER || settings?.general?.debug >= DebugLevel.ERRORS ? realError?.stack : translate(`common:errorHandler.sIntErrors.${code}.details`),
                      }
                    : undefined
            }
            description={translate(['unknown', 'networkError', 'runtimeError'].includes(realError?.code) ? 'common:errorHandler.error.subtitle' : `common:errorHandler.sIntErrors.${code}.details`)}
            heading={translate(['unknown', 'networkError', 'runtimeError'].includes(realError?.code) ? 'common:errorHandler.error.heading' : `common:errorHandler.sIntErrors.${code}.title`)}
            level="error"
            module={module}
            settings={settings}
        />
    );
}
